import { MouseEvent, TouchEvent, useCallback, useEffect, useMemo, useState } from 'react'

import { PauseIcon, PlayIcon, SkipForwardIcon, SkipToEndIcon } from '@verbit-ai/icons-library'

import { LiveState } from 'src/mocks/LiveEventPlayer'

import * as S from './styles'

export const MockReplayController = () => {
    const player = useMemo(() => document.mocks.getLiveEventPlayer(), [])
    const [isPlaying, setIsPlaying] = useState(player?.getCurrentPlayerState() === 'playing')
    const [liveState, setLiveState] = useState<LiveState>({ index: 0, length: 0 })

    const onPlayPauseToggle = useCallback(
        (e: MouseEvent | TouchEvent) => {
            e.preventDefault()
            e.stopPropagation()

            if (isPlaying) {
                player.pause()
            } else {
                player.play()
            }
        },
        [isPlaying, player],
    )

    const onStepForward = useCallback(
        (e: MouseEvent | TouchEvent, count?: number) => {
            e.preventDefault()
            e.stopPropagation()

            if (isPlaying) return

            player.step(count)
        },
        [isPlaying, player],
    )

    const onStep10StepsForward = useCallback((e: MouseEvent | TouchEvent) => onStepForward(e, 100), [onStepForward])

    useEffect(() => {
        const onPlay = () => setIsPlaying(true)
        const onPause = () => setIsPlaying(false)

        player.on('play', onPlay)
        player.on('pause', onPause)
        player.on('live_state_update', setLiveState)

        return () => {
            player.off('play', onPlay)
            player.off('pause', onPause)
            player.off('live_state_update', setLiveState)
        }
    }, [player])

    return (
        <>
            <S.TextWrapper>
                {liveState.index} / {liveState.length}
            </S.TextWrapper>

            <S.IconWrapper onClick={onPlayPauseToggle} onTouchStart={onPlayPauseToggle} disabled={liveState.index + 1 >= liveState.length}>
                {isPlaying ? <PauseIcon /> : <PlayIcon />}
            </S.IconWrapper>

            <S.IconWrapper
                onClick={onStepForward}
                onTouchStart={onStepForward}
                disabled={isPlaying || liveState.index + 1 >= liveState.length}>
                <SkipForwardIcon />
            </S.IconWrapper>

            <S.IconWrapper
                onClick={onStep10StepsForward}
                onTouchStart={onStep10StepsForward}
                disabled={isPlaying || liveState.index + 10 >= liveState.length}>
                <SkipToEndIcon />
            </S.IconWrapper>

            <S.TextWrapper>
                <i>next:</i>{' '}
                {liveState.index + 1 === liveState.length ? '-' : document.mocks.getLiveEvents()?.[liveState.index + 1]?.action}
            </S.TextWrapper>
        </>
    )
}
